/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface PasswordReminderPayload {
    passwordChangeTypeId: string;
    loginID?: string;
    email?: string;
    type?: string;
    inputValue?: string;
}

class PasswordReminderService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "passwordReminder/sendMail");
    }

    public async passwordReminder(payload: PasswordReminderPayload, resolved: () => void, rejected: (error: any) => void) {
        await super.postJSON(payload, resolved, rejected);
    }
}

export default PasswordReminderService;
